import * as React from "react";

import { WEIGHT_NORMAL } from "@hl/base-components/lib/theme/typography";
import { Box, Flex, Menu, Stack, useMantineTheme } from "@mantine/core";
import { IconDots } from "@tabler/icons";

import { DetailSectionApollo } from "~features/MintPage/apollo/DetailSectionApollo";
import BridgeLinks from "~features/MintPage/components/BridgeLinks";
import { DetailSectionViewFields } from "~features/MintPage/components/DetailSection/DetailSectionViewFields";
import RefreshCollectionMetadataButton from "~features/MintPage/refresh-metadata/RefreshCollectionMetadataButton";
import { isActiveSale } from "~features/MintPage/utils/statuses";
import useMintState from "~hooks/useMintState";

const CollectionInfoHeaderMenu = ({ hasBanner }: { hasBanner?: boolean }) => {
  const theme = useMantineTheme();
  const { collection, tokens, mintVector, saleStatus } = useMintState();

  return (
    <Menu
      width={340}
      transition="pop"
      position="bottom-end"
      transitionDuration={100}
      radius={14}
      withinPortal
      styles={{
        dropdown: {
          maxHeight: "70vh",
          overflowY: "auto",
        },
        item: {
          fontSize: 14,
          fontWeight: WEIGHT_NORMAL,
          cursor: "default",
          "&[data-hovered]": {
            backgroundColor: theme.colors.primaryBackground[0],
          },
        },
      }}
    >
      <Menu.Target>
        <Flex px="xs" h={36} sx={{ cursor: "pointer", alignItems: "center" }}>
          <IconDots
            color={
              theme.colorScheme === "dark" || hasBanner ? "white" : "black"
            }
          />
        </Flex>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item>
          <Stack spacing={0} onClick={(e) => e.stopPropagation()}>
            <DetailSectionApollo token={tokens[0]} />
            <DetailSectionViewFields noBottomDivider isApollo />
            <RefreshCollectionMetadataButton compact />
            {!isActiveSale(saleStatus!) && (
              <Box pt="sm">
                <BridgeLinks
                  chainId={collection?.chainId ?? 1}
                  paymentCurrency={mintVector?.paymentCurrency}
                  isApollo
                />
              </Box>
            )}
          </Stack>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};

export default CollectionInfoHeaderMenu;
